import { Fragment } from 'react'

import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon, XMarkIcon } from '@heroicons/react/20/solid'

import { BasicNomenclator } from '../../interfaces/ServerInterfaces'
import Checkbox from '../forms/Checkbox'

interface MultiBtn<T extends BasicNomenclator> {
  btnName?: string
  data: T[]
  selected: T[]
  setSelected: (_items: T[]) => void
  onClear?: () => void
}

export default function MultipleFilterBtn<T extends BasicNomenclator>({
  btnName,
  data,
  selected,
  setSelected,
  onClear,
}: MultiBtn<T>) {
  return (
    <div className="inline-flex flex-shrink-0 shadow-sm">
      <Menu as="div" className="relative -ml-px block">
        <Menu.Button
          className={[
            'relative inline-flex items-center gap-2',
            'rounded-md border-none bg-white px-2 py-2 text-gray-700',
            'ring-1 ring-inset ring-gray-300',
            'focus:z-10 hover:bg-gray-50',
          ].join(' ')}
        >
          <span className="inline-flex items-center justify-center gap-2 divide-x pl-2">
            <>
              {btnName ?? 'Filtros'}
              <ChevronDownIcon aria-hidden="true" className="h-5 w-5" />
            </>
            {onClear && (
              <button
                className="pl-2 pr-1"
                onClick={(e) => {
                  e.preventDefault()
                  onClear()
                }}
              >
                <XMarkIcon aria-hidden="true" className="h-5 w-5" />
              </button>
            )}
          </span>
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className={[
              'absolute right-0 z-10 -mr-1 mt-2',
              'max-h-[50dvh] w-56 origin-top-right overflow-y-scroll',
              'rounded-md bg-white shadow-lg',
              'ring-1 ring-black ring-opacity-5',
              'focus:outline-none',
            ].join(' ')}
          >
            <div className="p-1">
              <Checkbox
                data={data}
                displayCol
                selected={selected}
                setSelected={setSelected}
              />
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}
